import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
}
export function SectionTag({
  children,
  className = ''
}: SectionTagProps) {
  return <span className={`inline-block rounded-full border border-rose/30 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-rose-deep ${className}`} data-id="element-176" data-mp="1wr5vit8t5x6d">
      {children}
    </span>;
}